module.exports = __webpack_public_path__ + "img/objCalendar.99c510c1.svg";